"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTask = exports.getForbidSend = exports.forbidSendFmp = exports.flushJobs = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jobs = require("./jobs");
var _index = require("./performance/index");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
 * 计算异步指标参数队列
 * 1. 核心必备指标  fmp - netSpeed 参数默认必须计算完成
 * 2. 附加指标 lcp / fid / cls 可选计算
 * 3. 超时时间为 10s
 */
// 禁止默认发送
var forbidSend = false;
//
var options;

// 由于目前上报 必须上报完整的backup参数到后端，
// 因此需要上报前需要获取所有要上报的参数

// ios webview 不支持 web-vitals
var ua = typeof window === 'undefined' ? '' : window.navigator.userAgent.toLowerCase();
var isIOS = function isIOS() {
  return /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
};
var noSupportWebVital = function noSupportWebVital() {
  return typeof window !== 'undefined' && !window.PerformanceObserver || isIOS();
};
var _queues = noSupportWebVital() ? [{
  type: 'fmp',
  promise: _jobs.calcFmp,
  necessary: true //该异步任务必须执行完
}] : [{
  type: 'fmp',
  promise: _jobs.calcFmp,
  necessary: true //该异步任务必须执行完
}, {
  type: 'lcp',
  promise: _jobs.calcLCP,
  necessary: false
}, {
  type: 'cls',
  promise: _jobs.calcCLS,
  necessary: false
}, {
  type: 'fid',
  promise: _jobs.calcFID,
  necessary: false
}];
// 将都会执行的任务合并进队列
_queues = [{
  type: 'fetchStart',
  // 进入页面节点
  promise: _jobs.calcFetchStart,
  necessary: true
}, {
  type: 'domLoading',
  // js、css等静态文件加载完成节点
  promise: _jobs.calcDomLoading,
  necessary: true
}, {
  type: 'pageOpenNative',
  // 客户端开始跳转时间节点
  promise: _jobs.calcPageOpenNative,
  necessary: false
}, {
  type: 'pageshow',
  // 埋点pageshow完成节点
  promise: _jobs.calcPageshow,
  necessary: false
}].concat((0, _toConsumableArray2.default)(_queues), [{
  type: 'pageload',
  // 页面load完成节点
  promise: _jobs.calcPageload,
  necessary: false
}, {
  type: 'scrollStart',
  // 第一次触发滚动或拖动事件触发节点
  promise: _jobs.calcScrollStart,
  necessary: false
}, {
  type: 'pagehide',
  // 页面unload或隐藏节点
  promise: _jobs.calcPagehide,
  necessary: false
}]);
var NOOP = function NOOP() {};
var flushJobs = exports.flushJobs = function flushJobs() {
  var queues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _queues;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve) {
    var _options$onFmp = options.onFmp,
      onFmp = _options$onFmp === void 0 ? NOOP : _options$onFmp,
      _options$onLcp = options.onLcp,
      onLcp = _options$onLcp === void 0 ? NOOP : _options$onLcp,
      _options$openMeasure = options.openMeasure,
      openMeasure = _options$openMeasure === void 0 ? false : _options$openMeasure;
    // 未打开度量统计时，将下列任务过滤掉
    if (!openMeasure) {
      queues = queues.filter(function (item) {
        return !['fetchStart', 'domLoading', 'pageOpenNative', 'pageshow', 'pageload', 'scrollStart', 'pagehide'].includes(item.type);
      });
    }
    var result = Array(queues.length).fill(0);
    var len = queues.length;
    queues.forEach(function (job, index) {
      job.promise().then(function (res) {
        if (forbidSend) return resolve([]);
        if (job.type === 'lcp') onLcp(res);
        if (job.type === 'fmp') onFmp(res);
        result[index] = res;
        for (var i = 0; i < len; i++) {
          if (queues[i].necessary && !result[i]) {
            return;
          }
        }
        // 计算完之后等 500ms， 为了让 result 能在有效时间范围内带更多参数
        // 经过测试，lcp/fid 触发时机往往比fmp 晚
        setTimeout(function () {
          resolve(result);
        }, 500);
      }).catch(function () {});
    });
  });
};

/**
 * 所有异步计算任务
 * 执行流程：
 * LCP / CLS / FID / FMP （异步指标数据并行计算, fmp lcp为必须参数）
 * => NetSpeed (后延执行 防止影响首屏性能)
 * => performance (performance 同步参数计算)
 */
var initTask = exports.initTask = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var opts,
      fmp,
      cls,
      fid,
      lcp,
      fetchStart,
      domLoading,
      pageOpenNative,
      netSpeed,
      resVital,
      _iterator,
      _step,
      item,
      resNS,
      _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          // run
          options = opts;
          fmp = 0, cls = 0, fid = 0, lcp = 0, fetchStart = 0, domLoading = 0, pageOpenNative = 0, netSpeed = 0; //
          resVital = [];
          _context.prev = 4;
          _context.next = 7;
          return flushJobs(_queues, options);
        case 7:
          resVital = _context.sent;
          _context.next = 12;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](4);
        case 12:
          if (resVital.length) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("return");
        case 14:
          _iterator = _createForOfIteratorHelper(resVital);
          _context.prev = 15;
          _iterator.s();
        case 17:
          if ((_step = _iterator.n()).done) {
            _context.next = 35;
            break;
          }
          item = _step.value;
          _context.t1 = item === null || item === void 0 ? void 0 : item.type;
          _context.next = _context.t1 === 'fmp' ? 22 : _context.t1 === 'lcp' ? 24 : _context.t1 === 'fid' ? 26 : _context.t1 === 'cls' ? 28 : _context.t1 === 'fetchStart' ? 29 : _context.t1 === 'domLoading' ? 30 : _context.t1 === 'pageOpenNative' ? 31 : 32;
          break;
        case 22:
          fmp = item === null || item === void 0 ? void 0 : item.value;
          return _context.abrupt("continue", 33);
        case 24:
          lcp = item === null || item === void 0 ? void 0 : item.value;
          return _context.abrupt("continue", 33);
        case 26:
          fid = item === null || item === void 0 ? void 0 : item.value;
          return _context.abrupt("continue", 33);
        case 28:
          cls = item === null || item === void 0 ? void 0 : item.value;
        case 29:
          fetchStart = item === null || item === void 0 ? void 0 : item.value;
        case 30:
          domLoading = item === null || item === void 0 ? void 0 : item.value;
        case 31:
          pageOpenNative = item === null || item === void 0 ? void 0 : item.value;
        case 32:
          return _context.abrupt("continue", 33);
        case 33:
          _context.next = 17;
          break;
        case 35:
          _context.next = 40;
          break;
        case 37:
          _context.prev = 37;
          _context.t2 = _context["catch"](15);
          _iterator.e(_context.t2);
        case 40:
          _context.prev = 40;
          _iterator.f();
          return _context.finish(40);
        case 43:
          _context.prev = 43;
          _context.next = 46;
          return (0, _jobs.calcNetSpeed)();
        case 46:
          resNS = _context.sent;
          netSpeed = +(resNS === null || resNS === void 0 ? void 0 : resNS.value) || 0;
          _context.next = 52;
          break;
        case 50:
          _context.prev = 50;
          _context.t3 = _context["catch"](43);
        case 52:
          //
          (0, _index.setData)({
            netSpeed: netSpeed,
            fmp: fmp,
            cls: cls,
            fid: fid,
            lcp: lcp,
            fetchStart: fetchStart,
            domLoading: domLoading,
            pageOpenNative: pageOpenNative
          });
          (0, _index.sendData)(options, forbidSend);
        case 54:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 10], [15, 37, 40, 43], [43, 50]]);
  }));
  return function initTask() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * hack 兼容旧业务代码旧写法， 对外提供方法 forbidSendFmp 禁用默认发送
 * window['ZZ_LEGO_PERF_SYMBOL'].forbidSendFmp()
 */
var key = 'ZZ_LEGO_PERF_SYMBOL';
var forbidSendFmp = exports.forbidSendFmp = function forbidSendFmp() {
  return forbidSend = true;
};
var getForbidSend = exports.getForbidSend = function getForbidSend() {
  return forbidSend;
};
if (typeof window !== 'undefined') {
  if (!window[key]) {
    window[key] = {};
  }
  window[key].forbidSendFmp = forbidSendFmp;
  window[key].getForbidSend = getForbidSend;
}